import _ from 'lodash';

import PutSnippetBase from './put_snippet_base';

export default class UpdateSnippet extends PutSnippetBase {
  runAction(attrs) {
    this.context.gateways.snippet.update(attrs.id, _.omit(attrs, 'id'));
  }
}
